import DefaultValue from '@/defaultValue';
import Adresse from '@/generated/classes/Adresse';

export default class AdresseExtend  extends Adresse {

  constructor() {
    super();
    const value =  DefaultValue.defaultValueMap.get('pays');
    this.paysId = value ? value : 0;
  }
}
